import React, { useCallback, useContext, useMemo } from 'react'
import { rem } from 'polished'
import noop from 'lib/function/noop'
import styled from 'styled-components'
import cx from 'clsx'
import { GlobalSearchDispatchContext, GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import Heading from 'components/Luxkit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import FilterChip from 'components/Luxkit/Chips/FilterChip'

const HowLongGrid = styled.div`
  display: flex;
  gap: ${rem(12)};
  flex-wrap: wrap;
  justify-content: center;
`

interface CruiseDurationOption {
  name: string;
  min: number | null;
  max: number | null;
}

export const CruiseDurationOptions = [
  { name: 'Any duration', min: null, max: null },
  { name: '1 - 4 Nights', min: 1, max: 4 },
  { name: '5 - 8 Nights', min: 5, max: 8 },
  { name: '9 - 14 Nights', min: 9, max: 14 },
  { name: '15+ Nights', min: 15, max: null },
]

interface Props {
  onSelect?: () => void;
  onChange?: (value: App.CruiseGlobalFilters) => void;
  drawerMode?: boolean;
}

function CruiseWhenSelectContentHowLong(props: Props) {
  const { drawerMode, onSelect = noop, onChange = noop } = props
  const { durationMin, durationMax } = useContext(GlobalSearchStateContext)
  const searchDispatch = useContext(GlobalSearchDispatchContext)

  const selectedItem = useMemo(() =>
    CruiseDurationOptions.find(opt => opt.min >= durationMin && opt.max <= durationMax),
  [durationMax, durationMin])

  const handlerSearch = useCallback((option: CruiseDurationOption) => {
    if (option === selectedItem) {
      // Same option, guess we toggled off, go back to empty
      searchDispatch({ type: GlobalSearchStateActions.SET_DURATION_RANGE, min: undefined, max: undefined })
      onChange({ durationMin: null, durationMax: null })
    } else {
      searchDispatch({ type: GlobalSearchStateActions.SET_DURATION_RANGE, min: option.min, max: option.max })
      onSelect()
      onChange({ durationMin: option.min, durationMax: option.max })
    }
  }, [onSelect, searchDispatch, selectedItem, onChange])

  return <VerticalSpacer gap={16} data-testid="cruise-when-select-how-long">
    <Heading align="center" variant="heading6">How long?</Heading>
    <HowLongGrid className={cx({ drawer: drawerMode })}>
      {CruiseDurationOptions.map((option) => {
        return <FilterChip
          size="medium"
          key={option.name}
          onClick={() => handlerSearch(option)}
          selected={option === selectedItem}
        >
          {option.name}
        </FilterChip>
      })}
    </HowLongGrid>
  </VerticalSpacer>
}

export default CruiseWhenSelectContentHowLong
